export default "__VITE_ASSET__Da0wWV9b__"